// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"286": "95236df4","366": "9154912f","654": "f4374f49","985": "482cb750",}[chunkId] + ".css"
}